import { AttributesEditorDataSource } from '../../../../shared-app-portal/components/attributes-editor/attributesEditorDataSource';
import { PaymentResult, PaymentType } from './paymentOptions';
import { Image } from 'src/app/people/models/image';
import { AttributeWrite } from '../attributes/attributeWrite';
import { ComplexAttributeWrite } from '../attributes/complexAttributeWrite';
import { PersonApplicationWrite } from 'src/app/people/models/personApplicationWrite.model';

export interface IApplicationSubmit {
  personId: string;
  person: PersonApplicationWrite;
  image: { imageId: string };
  attributes: AttributeWrite[];
  complexAttributes: ComplexAttributeWrite[][];
  payment: {
    paymentIntentId: string;
    paymentMethodType: PaymentType;
  };
}

export interface IPaymentPreview extends Omit<IApplicationSubmit, 'image' | 'payment'> {}

export const buildApplicationSubmit = (
  person: PersonApplicationWrite,
  attributesEditorDataSource: AttributesEditorDataSource,
  personId: string,
  stripeResult: PaymentResult,
  image: Image
): IApplicationSubmit => {
  return {
    ...buildPaymentPreview(person, attributesEditorDataSource, personId),
    payment: {
      paymentIntentId: stripeResult?.paymentIntentId,
      paymentMethodType: stripeResult?.paymentType
    },
    image: image?.id ? { imageId: image.id } : null
  };
};

export const buildPaymentPreview = (
  person: PersonApplicationWrite,
  attributesEditorDataSource: AttributesEditorDataSource,
  personId: string
): IPaymentPreview => {
  const { attributes, complexAttributes } = attributesEditorDataSource.getWriteAttributes();

  return {
    person: person,
    attributes: attributes,
    complexAttributes: complexAttributes,
    personId: personId
  };
};
